import Reveal from '@/components/base/Reveal';
import { trustPillars, trustStats } from '@/mocks/home';

export default function Trust() {
  return (
    <section id="trust" className="border-y border-background-200/70 bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-7">
            <div className="flex items-center gap-2 text-xs font-medium uppercase tracking-[0.2em] text-secondary-700 md:text-sm">
              <span className="h-px w-6 bg-secondary-500" />
              平台保障
            </div>
            <h2 className="mt-3 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-4xl">
              看得开心，更要看得安心
            </h2>
            <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
              糖豆视频从主播认证、内容审核到隐私保护层层把关，让追直播这件事既热闹也踏实。
            </p>

            <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2">
              {trustPillars.map((item, index) => (
                <Reveal key={item.title} delay={(index % 2) * 70}>
                  <div className="flex h-full gap-3 rounded-xl border border-background-200 bg-background-50 p-4 md:p-5">
                    <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-primary-100 text-primary-700">
                      <i className={`${item.icon} text-xl`} />
                    </span>
                    <div>
                      <h3 className="font-heading text-base font-bold text-foreground-950">{item.title}</h3>
                      <p className="mt-1 text-xs leading-relaxed text-foreground-600 md:text-sm">{item.desc}</p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>

          <div className="lg:col-span-5">
            <Reveal delay={120}>
              <div className="rounded-2xl border border-background-200 bg-background-50 p-6 md:p-7">
                <div className="flex items-center gap-2">
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-accent-100 text-accent-700">
                    <i className="ri-verified-badge-line text-lg" />
                  </span>
                  <h3 className="font-heading text-base font-bold text-foreground-950">平台关键数据</h3>
                </div>
                <dl className="mt-6 grid grid-cols-2 gap-6">
                  {trustStats.map((stat) => (
                    <div key={stat.label}>
                      <dt className="font-heading text-2xl font-bold text-primary-600 md:text-3xl">{stat.value}</dt>
                      <dd className="mt-1 text-xs text-foreground-500 md:text-sm">{stat.label}</dd>
                    </div>
                  ))}
                </dl>

                <div className="mt-6 flex items-start gap-3 rounded-xl bg-secondary-50 p-4">
                  <i className="ri-alarm-warning-line mt-0.5 text-lg text-secondary-700" />
                  <p className="text-xs leading-relaxed text-foreground-700 md:text-sm">
                    7×24 小时内容巡检机制，违规内容即时下线；如有任何疑问，可随时通过站内客服反馈处理。
                  </p>
                </div>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}